// DO NOT EDIT -- generated from fs/services/dx-objects/admin.proto

import { DashboardWithCards } from './model.proto';
import { ObjectType } from './modeltypes.proto';
import { ObjectReferences } from './objectreferences.proto';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';

export namespace Admin {

  export const MigrateDefaultSpacesToZeroStateEndpoint = "/grpc/dx_objects.Admin/MigrateDefaultSpacesToZeroState";
  export function MigrateDefaultSpacesToZeroState(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MigrateDefaultSpacesToZeroStateEndpoint),
      endpoint: MigrateDefaultSpacesToZeroStateEndpoint
    };
  }

  export const GetParentObjectReferencesEndpoint = "/grpc/dx_objects.Admin/GetParentObjectReferences";
  export function GetParentObjectReferences(sender: (req: GetParentObjectReferencesRequest, endpoint: string) => Promise<GetParentObjectReferencesResponse>, req: GetParentObjectReferencesRequest): { promise: () => Promise<GetParentObjectReferencesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetParentObjectReferencesEndpoint),
      endpoint: GetParentObjectReferencesEndpoint
    };
  }

  export const GetChildObjectReferencesEndpoint = "/grpc/dx_objects.Admin/GetChildObjectReferences";
  export function GetChildObjectReferences(sender: (req: GetChildObjectReferencesRequest, endpoint: string) => Promise<GetChildObjectReferencesResponse>, req: GetChildObjectReferencesRequest): { promise: () => Promise<GetChildObjectReferencesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetChildObjectReferencesEndpoint),
      endpoint: GetChildObjectReferencesEndpoint
    };
  }

  export const GetObjectViewCountEndpoint = "/grpc/dx_objects.Admin/GetObjectViewCount";
  export function GetObjectViewCount(sender: (req: GetObjectViewCountRequest, endpoint: string) => Promise<GetObjectViewCountResponse>, req: GetObjectViewCountRequest): { promise: () => Promise<GetObjectViewCountResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetObjectViewCountEndpoint),
      endpoint: GetObjectViewCountEndpoint
    };
  }

  export const GetObjectViewCountByDateEndpoint = "/grpc/dx_objects.Admin/GetObjectViewCountByDate";
  export function GetObjectViewCountByDate(sender: (req: GetObjectViewCountByDateRequest, endpoint: string) => Promise<GetObjectViewCountResponse>, req: GetObjectViewCountByDateRequest): { promise: () => Promise<GetObjectViewCountResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetObjectViewCountByDateEndpoint),
      endpoint: GetObjectViewCountByDateEndpoint
    };
  }

  export const MigrateObjectsToSQLEndpoint = "/grpc/dx_objects.Admin/MigrateObjectsToSQL";
  export function MigrateObjectsToSQL(sender: (req: MigrateObjectsToSQLRequest, endpoint: string) => Promise<{}>, req: MigrateObjectsToSQLRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MigrateObjectsToSQLEndpoint),
      endpoint: MigrateObjectsToSQLEndpoint
    };
  }

  export const VerifyMigrateObjectsToSQLEndpoint = "/grpc/dx_objects.Admin/VerifyMigrateObjectsToSQL";
  export function VerifyMigrateObjectsToSQL(sender: (req: VerifyMigrateObjectToSQLRequest, endpoint: string) => Promise<VerifyMigrateObjectToSQLResponse>, req: VerifyMigrateObjectToSQLRequest): { promise: () => Promise<VerifyMigrateObjectToSQLResponse>, endpoint: string } {
    return {
      promise: () => sender(req, VerifyMigrateObjectsToSQLEndpoint),
      endpoint: VerifyMigrateObjectsToSQLEndpoint
    };
  }

  export const CleanUpObjectViewsEndpoint = "/grpc/dx_objects.Admin/CleanUpObjectViews";
  /** CleanupObjectViews deletes all rows from the object_views table older than given days. */
  export function CleanUpObjectViews(sender: (req: CleanUpObjectViewsRequest, endpoint: string) => Promise<{}>, req: CleanUpObjectViewsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CleanUpObjectViewsEndpoint),
      endpoint: CleanUpObjectViewsEndpoint
    };
  }

  export const CleanupOrphanedDashboardsEndpoint = "/grpc/dx_objects.Admin/CleanupOrphanedDashboards";
  export function CleanupOrphanedDashboards(sender: (req: CleanupOrphanedDashboardsRequest, endpoint: string) => Promise<CleanupOrphanedDashboardsResponse>, req: CleanupOrphanedDashboardsRequest): { promise: () => Promise<CleanupOrphanedDashboardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CleanupOrphanedDashboardsEndpoint),
      endpoint: CleanupOrphanedDashboardsEndpoint
    };
  }

  export const UpdateImpersonatorsEndpoint = "/grpc/dx_objects.Admin/UpdateImpersonators";
  export function UpdateImpersonators(sender: (req: UpdateImpersonatorsRequest, endpoint: string) => Promise<UpdateImpersonatorsResponse>, req: UpdateImpersonatorsRequest): { promise: () => Promise<UpdateImpersonatorsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateImpersonatorsEndpoint),
      endpoint: UpdateImpersonatorsEndpoint
    };
  }

  export const BackfillTupleDataToGrantEndpoint = "/grpc/dx_objects.Admin/BackfillTupleDataToGrant";
  export function BackfillTupleDataToGrant(sender: (req: BackfillTupleDataToGrantRequest, endpoint: string) => Promise<BackfillTupleDataToGrantResponse>, req: BackfillTupleDataToGrantRequest): { promise: () => Promise<BackfillTupleDataToGrantResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BackfillTupleDataToGrantEndpoint),
      endpoint: BackfillTupleDataToGrantEndpoint
    };
  }

  export const DeleteAllObjectsEndpoint = "/grpc/dx_objects.Admin/DeleteAllObjects";
  export function DeleteAllObjects(sender: (req: DeleteAllObjectsRequest, endpoint: string) => Promise<{}>, req: DeleteAllObjectsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteAllObjectsEndpoint),
      endpoint: DeleteAllObjectsEndpoint
    };
  }
}

export interface GetChildObjectReferencesRequest {
  orgId: string;
  parentObjId: string;
  parentObjectType: ObjectType;
}

export interface GetObjectViewCountRequest {
  orgId: string;
  objectId: string;
  objectType: ObjectType;
}

export interface GetObjectViewCountByDateRequest {
  orgId: string;
  objectId: string;
  objectType: ObjectType;
  /** The date from which to count views. */
  since: protobuf.timestamp | null;
}

export interface GetObjectViewCountResponse {
  viewCount: protobuf.int64;
}

export interface GetChildObjectReferencesResponse {
  references: ObjectReferences | null;
}

export interface GetParentObjectReferencesRequest {
  orgId: string;
  childObjId: string;
  childObjectType: ObjectType;
}

export interface GetParentObjectReferencesResponse {
  references: ObjectReferences | null;
}

export interface MigrateObjectsToSQLRequest {
  orgId: string;
  parallel: number;
  allObjects?: boolean;
  object?: ObjectType;
  acl?: boolean;
  /**
   * If true, will always overwrite what is in SQL.
   * Otherwise, will skip writes if SQL is up-to-date.
   */
  overwriteSql: boolean;
}

export namespace MigrateObjectsToSQLRequest {
  export enum type {
    allObjects = 3,
    object = 4,
    acl = 5
  }

  export function type_oneof(m: MigrateObjectsToSQLRequest): { opt: type.acl, val: boolean } | { opt: type.allObjects, val: boolean } | { opt: type.object, val: ObjectType } | null {
    if (m.allObjects != null) { return { opt: type.allObjects, val: m.allObjects } }
    if (m.object != null) { return { opt: type.object, val: m.object } }
    if (m.acl != null) { return { opt: type.acl, val: m.acl } }
    return null;
  }
}

export interface VerifyMigrateObjectToSQLRequest {
  orgId: string;
  parallel: number;
  allObjects?: boolean;
  object?: ObjectType;
  acl?: boolean;
}

export namespace VerifyMigrateObjectToSQLRequest {
  export enum type {
    allObjects = 3,
    object = 4,
    acl = 5
  }

  export function type_oneof(m: VerifyMigrateObjectToSQLRequest): { opt: type.acl, val: boolean } | { opt: type.allObjects, val: boolean } | { opt: type.object, val: ObjectType } | null {
    if (m.allObjects != null) { return { opt: type.allObjects, val: m.allObjects } }
    if (m.object != null) { return { opt: type.object, val: m.object } }
    if (m.acl != null) { return { opt: type.acl, val: m.acl } }
    return null;
  }
}

export interface VerifyMigrateObjectToSQLResponse {
  /** Results keyed by object type (or "ACL") */
  results: { [key: string]: VerifyMigrateObjectToSQLResponse.Results };
}

export namespace VerifyMigrateObjectToSQLResponse {
  export interface ObjectDiff {
    type: ObjectType;
    dxObjectId: string;
    /** Object or ACL diff string */
    objectDiff: string;
    metadataDiff: string;
  }

  export interface Results {
    datastoreTotal: number;
    sqlTotal: number;
    match: number;
    mismatch: number;
    diffs: VerifyMigrateObjectToSQLResponse.ObjectDiff[];
  }
}

export interface CleanUpObjectViewsRequest {
  /** Number of days to keep. Must be > 31 */
  daysToKeep: number;
}

export interface MigrateObjectToSQLQueueMessage {
  orgId: string;
  dashboardWithCards?: DashboardWithCards | null;
  metric?: search_settings.MetricRecord | null;
  funnel?: search_settings.FunnelRecord | null;
  retention?: search_settings.RetentionMetricRecord | null;
  segment?: search_settings.SegmentRecord | null;
  heatmap?: search_settings.HeatmapRecord | null;
  journey?: search_settings.JourneyMapRecord | null;
  acl?: MigrateObjectToSQLQueueMessage.AccessControlList | null;
  overwrite: boolean;
}

export namespace MigrateObjectToSQLQueueMessage {
  export interface AccessControlList {
    objectId: string;
    type: ObjectType;
    owners: string[];
  }

  export enum data {
    dashboardWithCards = 2,
    metric = 3,
    funnel = 4,
    retention = 5,
    segment = 6,
    heatmap = 7,
    journey = 8,
    acl = 9
  }

  export function data_oneof(m: MigrateObjectToSQLQueueMessage): { opt: data.acl, val: MigrateObjectToSQLQueueMessage.AccessControlList } | { opt: data.dashboardWithCards, val: DashboardWithCards } | { opt: data.funnel, val: search_settings.FunnelRecord } | { opt: data.heatmap, val: search_settings.HeatmapRecord } | { opt: data.journey, val: search_settings.JourneyMapRecord } | { opt: data.metric, val: search_settings.MetricRecord } | { opt: data.retention, val: search_settings.RetentionMetricRecord } | { opt: data.segment, val: search_settings.SegmentRecord } | null {
    if (m.dashboardWithCards != null) { return { opt: data.dashboardWithCards, val: m.dashboardWithCards } }
    if (m.metric != null) { return { opt: data.metric, val: m.metric } }
    if (m.funnel != null) { return { opt: data.funnel, val: m.funnel } }
    if (m.retention != null) { return { opt: data.retention, val: m.retention } }
    if (m.segment != null) { return { opt: data.segment, val: m.segment } }
    if (m.heatmap != null) { return { opt: data.heatmap, val: m.heatmap } }
    if (m.journey != null) { return { opt: data.journey, val: m.journey } }
    if (m.acl != null) { return { opt: data.acl, val: m.acl } }
    return null;
  }
}

export interface CleanupOrphanedDashboardsRequest {
  orgId: string;
}

export interface CleanupOrphanedDashboardsResponse {
  deletedIds: string[];
}

export interface DeleteAllObjectsRequest {
  orgId: string;
}

export interface UpdateImpersonatorsRequest {
  orgId: string;
}

export interface UpdateImpersonatorsResponse {
  updatedIds: UpdateImpersonatorsResponse.ObjectId[];
}

export namespace UpdateImpersonatorsResponse {
  export interface ObjectId {
    id: string;
    type: ObjectType;
  }
}

export interface BackfillTupleDataToGrantRequest {
  orgId: string;
}

export interface BackfillTupleDataToGrantResponse {
  spacesFilled: protobuf.int64;
  objectsFilled: protobuf.int64;
}
